"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var convert_1 = require("../../utils/convert");
var WebServerBase = /** @class */ (function () {
    function WebServerBase(options) {
        this.serverUrl = options.serverUrl;
        this.port = options.port;
        this.webApiUrl = options.webApiUrl;
        this.licenceKey = options.licenceKey;
        this.userKey = options.userKey;
    }
    WebServerBase.prototype.getUri = function (controller, method, params) {
        var url = new URL(this.serverUrl + ":" + this.port + "/api/" + controller + "/" + method);
        Object.keys(params).forEach(function (key) { return url.searchParams.append(key, params[key]); });
        return url;
    };
    WebServerBase.prototype.fetch = function (controller, method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, apiResponse, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // immutable
                        params = Object.assign({}, params);
                        params.licenceKey = this.licenceKey;
                        url = this.getUri(controller, method, params).toString();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                                headers: this.getRequestHeaders()
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, getApiResponse(response)];
                    case 3:
                        apiResponse = _a.sent();
                        return [2 /*return*/, apiResponse];
                    case 4:
                        ex_1 = _a.sent();
                        return [2 /*return*/, getApiResponseForException(ex_1)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WebServerBase.prototype.fetchFile = function (controller, method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, blobResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // immutable
                        params = Object.assign({}, params);
                        params.licenceKey = this.licenceKey;
                        url = this.getUri(controller, method, params).toString();
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                                headers: this.getRequestMultipartHeaders()
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Could not fetch " + url +
                                (", received " + response.status));
                        }
                        return [4 /*yield*/, response.blob()];
                    case 2:
                        blobResult = _a.sent();
                        return [2 /*return*/, blobResult];
                }
            });
        });
    };
    WebServerBase.prototype.fetchHtml = function (controller, method, params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, apiResponse, htmlResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // immutable
                        params = Object.assign({}, params);
                        params.licenceKey = this.licenceKey;
                        url = this.getUri(controller, method, params).toString();
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                                headers: this.getRequestHtmlHeaders()
                            })];
                    case 1:
                        response = _a.sent();
                        apiResponse = {
                            Success: response.ok,
                            HttpStatus: response.status,
                            HttpStatusText: response.statusText,
                        };
                        if (!response.ok) {
                            return [2 /*return*/, apiResponse];
                        }
                        return [4 /*yield*/, response.text()];
                    case 2:
                        htmlResult = _a.sent();
                        apiResponse.Result = htmlResult;
                        return [2 /*return*/, apiResponse];
                }
            });
        });
    };
    WebServerBase.prototype.fetchFromDefaultPort = function (urlPath, params, isNewUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, apiResponse, ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // immutable
                        params = Object.assign({}, params);
                        params.licenceKey = this.licenceKey;
                        url = new URL(isNewUrl ? urlPath : this.serverUrl + "/" + urlPath);
                        if (isNewUrl) {
                            url.searchParams.append('searchText', params.search);
                        }
                        else {
                            Object.keys(params).forEach(function (key) { return url.searchParams.append(key, params[key]); });
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url.toString(), {
                                cache: "no-cache",
                                method: 'GET',
                                headers: this.getRequestHeaders()
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, getApiResponse(response)];
                    case 3:
                        apiResponse = _a.sent();
                        return [2 /*return*/, apiResponse];
                    case 4:
                        ex_2 = _a.sent();
                        return [2 /*return*/, getApiResponseForException(ex_2)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WebServerBase.prototype.fetchPOST = function (controller, method, body, urlParams, multiPart) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, bodyContent, response, apiResponse, ex_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            licenceKey: this.licenceKey
                        };
                        if (urlParams) {
                            Object.keys(urlParams)
                                .forEach(function (paramName) { return params[paramName] = urlParams[paramName]; });
                        }
                        url = this.getUri(controller, method, params).toString();
                        if (multiPart === true) {
                            bodyContent = body;
                        }
                        else {
                            bodyContent = body !== null && body !== undefined ? JSON.stringify(body, convert_1.jsonReplacer) : '';
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: bodyContent,
                                headers: multiPart ? this.getRequestMultipartHeaders() : this.getRequestHeaders()
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, getApiResponse(response)];
                    case 3:
                        apiResponse = _a.sent();
                        return [2 /*return*/, apiResponse];
                    case 4:
                        ex_3 = _a.sent();
                        return [2 /*return*/, getApiResponseForException(ex_3)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WebServerBase.prototype.getRequestHeaders = function () {
        if (this.userKey) {
            return {
                'Authorization': "Basic " + this.userKey,
                'Content-Type': "application/json;charset=UTF-8"
            };
        }
    };
    WebServerBase.prototype.getRequestHtmlHeaders = function () {
        if (this.userKey) {
            return {
                'Authorization': "Basic " + this.userKey,
                'Content-Type': "text/html; charset=utf-8"
            };
        }
    };
    WebServerBase.prototype.getRequestMultipartHeaders = function () {
        if (this.userKey) {
            return {
                'Authorization': "Basic " + this.userKey
            };
        }
    };
    WebServerBase.prototype.GetServerUrl = function () {
        return this.serverUrl;
    };
    WebServerBase.prototype.GetWebApiUrl = function () {
        return this.webApiUrl;
    };
    return WebServerBase;
}());
exports.WebServerBase = WebServerBase;
function getApiResponse(response) {
    return __awaiter(this, void 0, void 0, function () {
        var parsedResult, parsedAsErrorObject, hasError, apiResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getParsedResponse(response)];
                case 1:
                    parsedResult = _a.sent();
                    parsedAsErrorObject = parsedResult;
                    hasError = parsedAsErrorObject.errorCode !== undefined || parsedAsErrorObject.message !== undefined;
                    apiResponse = {
                        Success: response.ok && hasError === false,
                        HttpStatus: response.status,
                        HttpStatusText: response.statusText,
                        Message: parsedResult.message || parsedAsErrorObject.message || (response.ok === false ? response.statusText : undefined),
                        ErrorCode: parsedAsErrorObject.errorCode
                    };
                    if (!response.ok) {
                        return [2 /*return*/, apiResponse];
                    }
                    apiResponse.Result = parsedResult;
                    return [2 /*return*/, apiResponse];
            }
        });
    });
}
exports.getApiResponse = getApiResponse;
function getApiResponseForException(exception) {
    var apiResponse = {
        Success: false,
        HttpStatus: -1,
        HttpStatusText: typeof exception,
        Message: exception.message || typeof exception,
        ErrorCode: undefined
    };
    return apiResponse;
}
function getParsedResponse(response) {
    return __awaiter(this, void 0, void 0, function () {
        var textResponse, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.text()];
                case 1:
                    textResponse = _a.sent();
                    result = textResponse === '' ? '' : JSON.parse(textResponse, dateReviver);
                    return [2 /*return*/, Promise.resolve(result)];
            }
        });
    });
}
function dateReviver(key, value) {
    if (typeof value === "string" && types_1.dateFormat.test(value)) {
        var date = new Date(value);
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return date;
    }
    return value;
}
//# sourceMappingURL=WebServerBase.js.map